import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';

import ContractDetails from '../../../../../components/ContractDetails';
import DialogModal from '../../../../../components/DialogModal';
import SubmitButton from '../SubmitButton';
import texts from './texts.json';
import {
  Container,
  AgreementRow,
  StyledFormControlLabel,
  ReadTermsButton,
  ErrorText,
  ModalContent,
  ModalTitle,
  TermsScroll,
} from './styles';

/**
 * The client's agreement to the contract's terms, on the checkout's first page: a tick box, and the terms themselves
 * in a modal opened from "Read terms" — agreeing there ticks the box. Controlled: the caller owns `isChecked`.
 */
const TermsAgreement = ({
  isChecked,
  onChange,
  contractTerms,
  coachConditions,
  error,
  color,
  isDarkTheme,
}) => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleAgreeInModal = useCallback(() => {
    onChange(true);
    setIsTermsOpen(false);
  }, [onChange]);

  return (
    <Container>
      <AgreementRow>
        <StyledFormControlLabel
          $isDarkTheme={isDarkTheme}
          control={(
            <Checkbox
              checked={isChecked}
              onChange={(event) => onChange(event.target.checked)}
              color="primary"
            />
          )}
          label={texts.agree}
        />
        <ReadTermsButton type="button" onClick={() => setIsTermsOpen(true)} $isDarkTheme={isDarkTheme}>
          {texts.readTerms}
        </ReadTermsButton>
      </AgreementRow>
      {!!error && <ErrorText role="alert">{error}</ErrorText>}
      <DialogModal open={isTermsOpen} onClose={() => setIsTermsOpen(false)} aria-labelledby="checkout-terms-title">
        <ModalContent $isDarkTheme={isDarkTheme}>
          <ModalTitle id="checkout-terms-title" $isDarkTheme={isDarkTheme}>{texts.termsTitle}</ModalTitle>
          <TermsScroll>
            <ContractDetails
              contractTerms={contractTerms}
              coachConditions={coachConditions}
              isDarkTheme={isDarkTheme}
              isCheckoutPageview
            />
          </TermsScroll>
          <SubmitButton type="button" onClick={handleAgreeInModal} $background={color} $isDarkTheme={isDarkTheme}>
            {texts.agreeInModal}
          </SubmitButton>
        </ModalContent>
      </DialogModal>
    </Container>
  );
};

TermsAgreement.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  contractTerms: PropTypes.arrayOf(PropTypes.string),
  coachConditions: PropTypes.string,
  error: PropTypes.string,
  color: PropTypes.string,
  isDarkTheme: PropTypes.bool,
};

TermsAgreement.defaultProps = {
  contractTerms: [],
  coachConditions: '',
  error: '',
  color: '',
  isDarkTheme: false,
};

export default TermsAgreement;
